export default __webpack_public_path__ + "809cbfd850e0a6c36e74f468186deb8c.svg";